// @flow

import { List, Map, fromJS } from 'immutable';

export const GET_BOOKMARKS = 'App/bookmarks/GET_BOOKMARKS';
export const GET_BOOKMARKS_SUCCESS = 'App/bookmarks/GET_BOOKMARKS_SUCCESS';
export const GET_BOOKMARKS_FAIL = 'App/bookmarks/GET_BOOKMARKS_FAIL';
export const CLEAR_BOOKMARKS = 'App/bookmarks/CLEAR_BOOKMARKS';

const initialState = Map({
  getBookmarksLoading: false,
  bookmarksData: List([]),
  getBookmarksFail: null,
});

export default (state : any = initialState, action : any = {}) => {
  switch (action.type) {
    case GET_BOOKMARKS:
      return state.merge({
        getBookmarksLoading: true,
        getBookmarksFail: null,
      });
    case GET_BOOKMARKS_SUCCESS:
      return state.merge({
        getBookmarksLoading: false,
        bookmarksData: fromJS(action.data),
        getBookmarksFail: null,
      });
    case GET_BOOKMARKS_FAIL:
      return state.merge({
        getBookmarksLoading: false,
        getBookmarksFail: fromJS(action.data),
      });
    case CLEAR_BOOKMARKS:
      return state.set('bookmarksData', List([]));
    default:
      return state;
  }
};

export const getBookmarks = () => ({ type: GET_BOOKMARKS });

export const clearBookmarks = () => ({ type: CLEAR_BOOKMARKS });
